// extracted by mini-css-extract-plugin
export var logo = "_l6-2";
export var logoWrapper = "_l6-1";
export var strip = "_l6-0";